import { Skeleton } from "@/components/ui/skeleton";

interface ReferralTableSkeletonProps {
  rows?: number;
}

export function ReferralTableSkeleton({ rows = 5 }: ReferralTableSkeletonProps) {
  return (
    <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
      {/* Desktop Table Header */}
      <div className="hidden lg:grid grid-cols-6 gap-4 p-4 bg-gray-50 border-b border-gray-200 text-sm font-medium text-gray-500 space-grotesk uppercase tracking-wide">
        <div>CANDIDATE</div>
        <div>JOB TITLE</div>
        <div>STATUS</div>
        <div>REFERRAL DATE</div>
        <div>REWARD</div>
        <div>ACTIONS</div>
      </div>

      {/* Skeleton Rows */}
      <div className="divide-y divide-gray-200">
        {Array.from({ length: rows }).map((_, index) => (
          <div key={index} className="lg:grid lg:grid-cols-6 lg:gap-4 p-4">
            {/* Desktop Layout */}
            <div className="hidden lg:flex items-center gap-3">
              <Skeleton className="h-10 w-10 rounded-full" />
              <Skeleton className="h-4 w-32" />
            </div>

            <div className="hidden lg:flex items-center">
              <Skeleton className="h-4 w-40" />
            </div>

            <div className="hidden lg:flex items-center">
              <Skeleton className="h-6 w-20 rounded-xl" />
            </div>

            <div className="hidden lg:flex items-center">
              <Skeleton className="h-4 w-24" />
            </div>

            <div className="hidden lg:flex items-center">
              <Skeleton className="h-4 w-16" />
            </div>

            <div className="hidden lg:flex items-center">
              <Skeleton className="h-8 w-16 rounded" />
            </div>

            {/* Mobile Layout */}
            <div className="lg:hidden space-y-3">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <Skeleton className="h-10 w-10 rounded-full" />
                  <div className="space-y-1">
                    <Skeleton className="h-4 w-28" />
                    <Skeleton className="h-3 w-36" />
                  </div>
                </div>
                <Skeleton className="h-8 w-8 rounded" />
              </div>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <Skeleton className="h-6 w-20 rounded-xl" />
                  <Skeleton className="h-3 w-20" />
                </div>
                <Skeleton className="h-4 w-16" />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Pagination Skeleton */}
      <div className="border-t border-gray-200 bg-gray-50 px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2">
            <Skeleton className="h-4 w-10" />
            <Skeleton className="h-8 w-16 rounded" />
            <Skeleton className="h-4 w-16" />
          </div>
          <Skeleton className="h-4 w-40" />
        </div>

        <div className="flex items-center gap-2">
          <Skeleton className="h-8 w-20 rounded" />
          <div className="flex items-center gap-1">
            <Skeleton className="h-8 w-8 rounded" />
            <Skeleton className="h-8 w-8 rounded" />
            <Skeleton className="h-8 w-8 rounded" />
          </div>
          <Skeleton className="h-8 w-16 rounded" />
        </div>
      </div>
    </div>
  );
}
